import { render, staticRenderFns } from "./DatosProspectoEmpresa.vue?vue&type=template&id=2a11346c"
import script from "./DatosProspectoEmpresa.vue?vue&type=script&lang=js"
export * from "./DatosProspectoEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports